import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver/FileSaver';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class FileDownloadDataServiceProvider {
	constructor(private http: HttpClient) {}

	saveFileFromJob(fileId, jobId): Observable<HttpResponse<Blob>> {
		const url = `/rest/user/jobs/${jobId}/attachments/${fileId}`;
		return this.http.get(url, { responseType: 'blob', observe: 'response' });
	}

	saveClients(): Promise<void> {
		const url = '/protected/rest/clients/export-clients';
		return this.http
			.get(url, { responseType: 'blob', observe: 'response' })
			.toPromise()
			.then((response: HttpResponse<Blob>): void =>
				this.saveClientsToFileSystem(response)
			);
	}

	saveClientsTemplate(): Promise<void> {
		const url = '/protected/rest/clients/download-csv-template';
		return this.http
			.get(url, { responseType: 'blob', observe: 'response' })
			.toPromise()
			.then((response: HttpResponse<Blob>): void =>
				this.saveClientsTemplateToFileSystem(response)
			);
	}

	savePaymentsCSV(response): void {
		this.savePaymentsToFileSystemCSV(response);
	}

	savePaymentsXLS(response): void {
		this.savePaymentsToFileSystemXLS(response);
	}

	downloadPdf(
		linkToken: string,
		id: number,
		documentType?: string
	): Promise<void> {
		let url;
		switch (documentType) {
			case 'invoice':
				url = `/api/public/v1/invoice/${linkToken}/${id}/download-pdf`;
				break;
			case 'quote':
				url = `/api/public/v1/quotes/${linkToken}/${id}/download-pdf`;
				break;
			default:
				url = `/api/public/v1/quotes/${linkToken}/${id}/download-pdf`;
		}
		return this.http
			.get(url, { responseType: 'blob', observe: 'response' })
			.toPromise()
			.then((response: HttpResponse<Blob>): void =>
				this.saveToFileSystem(response)
			);
	}

	downloadPDF(url: string, name: string, id: number): Observable<Object> {
		return this.http
			.post(url, {}, { responseType: 'blob', observe: 'response' })
			.pipe(
				tap((response: HttpResponse<Blob>): void =>
					this.savePdf(response, name, id)
				)
			);
	}

	saveContractPdf(url: string, fileName: string): Promise<void> {
		return this.http
			.post(url, {}, { responseType: 'blob', observe: 'response' })
			.toPromise()
			.then((response: HttpResponse<Blob>): void => {
				const blob = new Blob([response.body], { type: response.body.type });
				saveAs(blob, fileName);
			});
	}

	saveToFileSystem(response: HttpResponse<Blob>): void {
		const contentDispositionHeader: string = response.headers.get(
			'Content-Disposition'
		);
		const parts: string[] = contentDispositionHeader.split(';');
		const filename = parts[1].split('=')[1];
		const blob = new Blob([response.body], { type: response.body.type });
		saveAs(blob, filename);
	}

	saveFile(response: HttpResponse<Blob>, name: string, fileType): void {
		const blob = new Blob([response.body], { type: response.body.type });
		saveAs(blob, `${name}.${fileType}`);
	}

	private savePdf(
		response: HttpResponse<Blob>,
		name: string,
		id: number
	): void {
		const blob = new Blob([response.body], { type: response.body.type });
		saveAs(blob, `${name}-${id}`);
	}

	private saveClientsToFileSystem(response: HttpResponse<Blob>): void {
		const blob = new Blob([response.body], { type: response.body.type });
		saveAs(blob, 'export_clients.csv');
	}

	private savePaymentsToFileSystemCSV(response: HttpResponse<Blob>): void {
		const blob = new Blob([response.body], { type: response.body.type });
		saveAs(blob, 'export_payments.csv');
	}

	private savePaymentsToFileSystemXLS(response: HttpResponse<Blob>): void {
		const blob = new Blob([response.body], { type: response.body.type });
		saveAs(blob, 'export_payments.xls');
	}

	private saveClientsTemplateToFileSystem(response: HttpResponse<Blob>): void {
		const blob = new Blob([response.body], { type: response.body.type });
		saveAs(blob, 'import_clients_template.csv');
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./shared/services/files/file-download-service/file-download.data.service.ts